import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Slider from "react-slick";

import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import Breadcrumb from "../../components/Breadcrumb";
import LearningCard from "../../components/LearningCard/index";
import ApiService from "../../services/ApiService";
import Courses from "../../components/Courses";
import Loader from "../../features/Loader";
import { use } from "react";

export default function Coursesbycategory() {
  // for fetching course to filter using dynamic route parameter
  const { category } = useParams();
  const { subCategory } = useParams();

  const [loaderStatus, setLoaderStatus] = useState(true);
  // const [courses, setCourses] = useState([]);

  const [Course, setCourse] = useState([]);

  const [courseByCategory, setCourseByCategory] = useState([]);

  // useEffect(() => {
  //   setCourseByCategory(Course.filter((course) => course.board === category.toUpperCase()));
  // }, [Course, category]);

  useEffect(() => {
  setCourseByCategory(
    Course.filter(
      (course) => course.board?.toLowerCase() === category?.toLowerCase()
    )
  );
}, [Course, category]);

  const fetchData = async () => {
    setLoaderStatus(true);
    if (subCategory) {
      try {
        const response = await ApiService.publicGetRequest(
          `/courses/findbysubcategory?subCategory=${subCategory}`,
        );
        console.log(response.data.data);
        if (response.data.data) {
          setCourse(response.data.data);
          console.log(response.data.data, "Course");
        } else {
          setCourse([]);
        }
        setLoaderStatus(false);
      } catch (error) {
        setCourse([]);
        setLoaderStatus(false);
        console.error("Error fetching courses:", error);
      }
    } else {
      try {
        // const response = await ApiService.publicPostRequest(
        //   "/courses/findbycategory",
        //   [category]
        // );
        const response = await ApiService.publicGetRequest(
          "/courses/findallcourses",
          // [category]
        );
        setLoaderStatus(false);
        if (response.data.data) {
          setCourse(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    }
  };

  //   useEffect(() => {
  //     fetchData();
  //   }, []);

  useEffect(() => {
    fetchData();
  }, [category, subCategory]);

  //   useEffect(() => {
  //     window.location.reload();
  //   }, [Course]);

  // =============Breadcrumb Path======
  const path = [
    { text: "Home", path: "/" },
    { text: "Course" }, // No path for the active page
    { text: `${subCategory ? subCategory : category}` }, // No path for the active page
  ];

  let settings = {
    dots: false,
    lazyLoad: true,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    prevArrow: (
      <button type="button" className="slick-prev">
        <FaChevronLeft />
      </button>
    ),
    nextArrow: (
      <button type="button" className="slick-next">
        <FaChevronRight />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const title =
      category.toUpperCase() + " " + (subCategory ? subCategory : " ") ||
      "Loading Course...";
    document.title = title;
  }, [category]);

  return (
    <>
      <div className="dashboard-wrapper bg2">
        <Container>
          {/* ============Breadcrumb ======= */}
          <Breadcrumb path={path} />
          {/* ============Breadcrumb ======= */}
          <Row>
            <Col sm={12}>
              <div className="content-box">
                <h2 className="title mb-3 text-capitalize">
                  {subCategory ? subCategory : category}
                </h2>

                <div className="container">
                  <Row className="my-3">
                    {loaderStatus && <Loader />}

                    {!loaderStatus && <Courses course={courseByCategory} />}
                    {/* {!loaderStatus && <Courses course={Course} />} */}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="container-fluid bg-grey">
        <Container className="  ">
          {/*   <h2 className="title ">
                        Top <sapn className="title-span">Recommended</sapn> Courses 

                    </h2> */}

          <div className="tabs-wrapper">
            <div className="slider-content">
              <div className="slider-container"></div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}
